import { GlassButton } from "@/components/ui/glass-button";
import { GlassCard, GlassCardContent, GlassCardDescription, GlassCardFooter, GlassCardHeader, GlassCardTitle } from "@/components/ui/glass-card";
import { zenitova } from "../../config/companies";
import type { CompanyData } from "../../config/companies/types";

function CompanyProfileCard({ metadata }: { metadata?: CompanyData }) {
  return (
    <GlassCard className="w-full max-w-xl my-4">
      <GlassCardHeader>
        <GlassCardTitle>{metadata?.title}</GlassCardTitle>
        <GlassCardDescription>{metadata?.address}</GlassCardDescription>
      </GlassCardHeader>
      <GlassCardContent>
        <GlassCardDescription>
          Vergi Dairesi: <b>{metadata?.taxOffice}</b>
        </GlassCardDescription>
        <GlassCardDescription>
          Vergi Numarasi: <b>{metadata?.taxNo}</b>
        </GlassCardDescription>
        <GlassCardDescription>
          Mersis veya Yurtdışı Kayıt Numarası: <b>{metadata?.registryId}</b>
        </GlassCardDescription>
        <GlassCardDescription className="flex">
          <span>Banka Bilgileri: </span> <b className="whitespace-pre-line">
            {metadata?.bankInfo}
          </b>
        </GlassCardDescription>
      </GlassCardContent>
      <GlassCardFooter>
      </GlassCardFooter>
    </GlassCard>
  );
}

export function CompanyProfile({ metadata }: { metadata?: CompanyData }) {
  return (
    <div>
      <div className="h-16 flex items-end justify-center gap-4 text-white text-2xl">
        <h1 className="flex-1 text-center pb-4">
          {/* Company Information and Deals */}
          Şirket Bilgileri ve Anlaşmalar
        </h1>
      </div>
      <CompanyProfileCard metadata={zenitova} />
      <CompanyProfileCard metadata={metadata} />
    </div>
  )
};